var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckedRadioBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#0061ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0829 9.77807C16.2828 9.5673 16.3033 9.24294 16.1445 9.00884C16.1441 9.00336 16.1432 8.99955 16.142 8.99771C16.1382 8.99262 16.1325 8.98541 16.1307 8.98322L16.1272 8.97917L16.1255 8.97726L16.123 8.97443L16.122 8.97336L16.1207 8.97202L16.0829 8.93206L16.0451 8.89217L16.0438 8.89084L16.0428 8.88979L16.0401 8.88706L16.0382 8.88525L16.0343 8.88152C16.0322 8.87955 16.0252 8.87334 16.0201 8.8692C16.0183 8.86786 16.0144 8.86677 16.0089 8.86604C15.7779 8.69168 15.4506 8.71381 15.244 8.93242L15.2439 8.93251L10.6658 13.7809L8.75576 11.7734C8.75565 11.7732 8.75554 11.7731 8.75543 11.773C8.52552 11.5301 8.14651 11.5302 7.91674 11.7734C7.69454 12.0085 7.69423 12.3841 7.91696 12.6192L7.91732 12.6196L10.2482 15.0691C10.2483 15.0692 10.2483 15.0693 10.2484 15.0693C10.4769 15.3103 10.8587 15.3102 11.0871 15.0691L11.0875 15.0688L16.0825 9.77849C16.0827 9.77835 16.0828 9.77821 16.0829 9.77807ZM16.083 8.93242L16.0827 8.93213L16.083 8.93242ZM16.0769 8.93817L16.077 8.93814L16.0769 8.93817Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRadioBtn);
export default ForwardRef;